import { BlockCategoryThemeConfig } from "@/protocols/chatBotFlow"
import { FlowBlockCategory } from "@/protocols/chatBotConstructor"
import { colors } from "@/styles/colors"

export const blockCategoryThemeConfig: Record<FlowBlockCategory["type"], BlockCategoryThemeConfig> = {
	action: {
		color: {
			blockHeaderBackground: colors.red[100],
			blockSelected: colors.red[800],
			blockIcon: colors.red[800]
		}
	},
	message: {
		color: {
			blockHeaderBackground: colors.green[100],
			blockSelected: colors.green[600],
			blockIcon: colors.green[600]
		}
	},
	attendance: {
		color: {
			blockHeaderBackground: colors.purple[100],
			blockSelected: colors.purple[800],
			blockIcon: colors.purple[800]
		}
	},
	"conditional-and-delay": {
		color: {
			blockHeaderBackground: colors.blue[100],
			blockSelected: colors.blue[700],
			blockIcon: colors.blue[700]
		}
	},
	ai: {
		color: {
			blockHeaderBackground: colors.purple[100],
			blockSelected: colors.purple[800],
			blockIcon: colors.purple[800]
		}
	},
	"active-campaign": {
		color: {
			blockHeaderBackground: colors.blue[100],
			blockSelected: colors.blue[700],
			blockIcon: colors.blue[700]
		}
	},
	"meta-ads": {
		color: {
			blockHeaderBackground: colors.blue[100],
			blockSelected: colors.blue[500],
			blockIcon: colors.blue[500]
		}
	},
	funnel: {
		color: {
			blockHeaderBackground: colors.blue[100],
			blockSelected: colors.blue[700],
			blockIcon: colors.blue[700]
		}
	},
	"rd-station": {
		color: {
			blockHeaderBackground: colors.blue[400],
			blockSelected: colors.blue[900],
			blockIcon: colors.blue[900]
		}
	},
	superlogica: {
		color: {
			blockHeaderBackground: colors.blue[100],
			blockSelected: colors.blue[700],
			blockIcon: colors.blue[700]
		}
	}
}
